/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-nested-ternary */
import { HStack, Box, IconButton, useTheme, Text, Tooltip, Icon } from '@chakra-ui/core';
import React from 'react';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineStarBorder, MdOutlineStar, MdAdd, MdOutlineRemove } from 'react-icons/md';
import colors from '../../../../styles/colors';

interface LanguageMenuItemContentProps {
  langValue: string;
  label: string;
  isDefault: boolean;
  isAvailableInForm: boolean;
  isCurrentlySelected: boolean;
  canSetDefault: boolean;
  canAdd: boolean;
  canRemove: boolean;
  onSetDefault: (langValue: string) => void;
  onAdd: (langValue: string) => void;
  onRemove: (langValue: string) => void;
  onSelectLanguage: (langValue: string) => void;
}

const LanguageMenuItemContent: FC<LanguageMenuItemContentProps> = React.memo(
  ({
    langValue,
    label,
    isDefault,
    isAvailableInForm,
    isCurrentlySelected,
    canSetDefault,
    canAdd,
    canRemove,
    onSetDefault,
    onAdd,
    onRemove,
    onSelectLanguage,
  }) => {
    const { t } = useTranslation('hrFormTemplate');
    const chakraTheme = useTheme();

    const memoizedHandleSetDefault = useCallback(() => onSetDefault(langValue), [onSetDefault, langValue]);
    const memoizedHandleAdd = useCallback(() => onAdd(langValue), [onAdd, langValue]);
    const memoizedHandleRemove = useCallback(() => onRemove(langValue), [onRemove, langValue]);

    return (
      <HStack justify="space-between" width="100%" spacing={1}>
        <HStack
          spacing={2}
          flexGrow={1}
          opacity={isAvailableInForm ? 1 : 0.6}
          cursor={isAvailableInForm && !isCurrentlySelected ? 'pointer' : 'default'}
          onClick={isAvailableInForm && !isCurrentlySelected ? () => onSelectLanguage(langValue) : undefined}
          width="full"
        >
          <Box minW="20px" textAlign="center">
            {isAvailableInForm ? (
              isCurrentlySelected ? (
                <Icon as={MdCheckBox} color="blue.500" boxSize={5} />
              ) : (
                <Icon as={MdCheckBoxOutlineBlank} boxSize={5} color="gray.400" />
              )
            ) : (
              <Box w="20px" />
            )}
          </Box>
          <Text textTransform="capitalize" fontSize="sm" fontWeight={isCurrentlySelected ? 'semibold' : 'normal'}>
            {label}
          </Text>
        </HStack>

        <HStack spacing={0.5} onClick={(e: any) => e.stopPropagation()}>
          {isAvailableInForm && !isDefault && canSetDefault && (
            <Tooltip label={t('formBuilder.languageSelectMenu.setAsPrimary')} placement="top" hasArrow>
              <IconButton
                icon={<Icon as={MdOutlineStarBorder} color={chakraTheme.colors.gray[400]} />}
                aria-label={t('formBuilder.languageSelectMenu.setAsPrimaryAria', { lang: label }) || `Set ${label} as primary`}
                data-testid={`set-default-language-${langValue}`}
                onClick={memoizedHandleSetDefault}
                variant="ghost"
                size="sm"
                sx={{
                  aspectRatio: '1/1',
                }}
                minW="auto"
                px={1}
              />
            </Tooltip>
          )}
          {isAvailableInForm && isDefault && (
            <Tooltip label={t('formBuilder.languageSelectMenu.primaryLanguage')} placement="top" hasArrow>
              <IconButton
                icon={<MdOutlineStar fontSize="medium" color={colors.green[600]} />}
                aria-label={t('formBuilder.languageSelectMenu.primaryLanguageAria') || 'Primary language'}
                variant="ghost"
                size="sm"
                sx={{
                  aspectRatio: '1/1',
                }}
                isDisabled
                minW="auto"
                flexShrink={0}
                px={1}
              />
            </Tooltip>
          )}
          {canAdd && (
            <Tooltip label={t('formBuilder.languageSelectMenu.addLanguage')} placement="top" hasArrow>
              <IconButton
                icon={<Icon as={MdAdd} />}
                aria-label={t('formBuilder.languageSelectMenu.addLanguageAria', { lang: label }) || `Add ${label}`}
                onClick={memoizedHandleAdd}
                data-testid={`add-language-${langValue}`}
                variant="ghost"
                size="sm"
                colorScheme="green"
                minW="auto"
                sx={{
                  aspectRatio: '1/1',
                }}
                px={1}
                flexShrink={0}
              />
            </Tooltip>
          )}
          {canRemove && (
            <Tooltip label={t('formBuilder.languageSelectMenu.removeLanguage')} placement="top" hasArrow>
              <IconButton
                icon={<Icon as={MdOutlineRemove} />}
                aria-label={t('formBuilder.languageSelectMenu.removeLanguageAria', { lang: label }) || `Remove ${label}`}
                onClick={memoizedHandleRemove}
                data-testid={`remove-language-${langValue}`}
                variant="ghost"
                size="sm"
                colorScheme="red"
                minW="auto"
                px={1}
                flexShrink={0}
                sx={{
                  aspectRatio: '1/1',
                }}
              />
            </Tooltip>
          )}
        </HStack>
      </HStack>
    );
  },
);

LanguageMenuItemContent.displayName = 'LanguageMenuItemContent';

export default LanguageMenuItemContent;
